import { INFORMATION_SOURCE } from 'cpool-constants';
import { z } from 'zod';

import { schemaApplicantAttributionBoth, schemaBigDecimal, schemaId } from '../../../utils/schema.utils';

export const Kontokorrentkredit = z.object({
    beanspruchterBetrag: schemaBigDecimal.nullish().default(null),
    createdAt: z.coerce.date().nullish(),
    gehoertZuAntragsteller: schemaApplicantAttributionBoth,
    glaeubiger: z.string().nullish().default(null),
    id: schemaId,
    source: z.nativeEnum(INFORMATION_SOURCE).optional().default(INFORMATION_SOURCE.FORMULAR),
    verfuegungsrahmen: schemaBigDecimal.nullish().default(null),
    zinssatz: schemaBigDecimal.nullish().default(null),
});

// INFO yup schema
//                         yup.object().shape(
//                             {
//                                 beanspruchterBetrag: yup.number().optional().nullable().default(null),
//                                 gehoertZuAntragsteller: yup
//                                     .string()
//                                     .oneOf(['ANTRAGSTELLER_1', 'ANTRAGSTELLER_2', 'BEIDE'])
//                                     .required(),
//                                 glaeubiger: yup.string().optional().nullable().default(null),
//                                 id: yup.string(),
//                                 source: yup.string().oneOf(['FORMULAR', 'SCHUFA']).optional().default('FORMULAR'),
//                                 verfuegungsrahmen: yup.number().optional().nullable().default(null),
//                                 zinssatz: yup.number().optional().nullable().default(null),
//                             },
//                             bankAccountFieldValidationOrder,
//                         ),
